import { render } from "./B2bFiltersCmrDraft.vue?vue&type=template&id=65b5a0af&scoped=true&lang=pug"
import script from "./B2bFiltersCmrDraft.vue?vue&type=script&lang=js"
export * from "./B2bFiltersCmrDraft.vue?vue&type=script&lang=js"

import "./B2bFiltersCmrDraft.vue?vue&type=style&index=0&id=65b5a0af&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b5a0af"]])

export default __exports__